<template>
  <div class="qr-code-container">
    <div class="title">
      <span>登录</span>
      <span class="high-light">智库</span>
    </div>
    <div class="sub-title">您可以通过微信扫描下方二维码直接登录</div>
    <div class="qr_code_box">
      <img :src="qrImg" alt="" />
      <div class="tip" @click="init" v-if="isNotWork">
        <div>已失效，点击刷新</div>
      </div>
    </div>
    <div class="form-bot">
      <div class="gap-row">或者</div>
      <div class="other-btn flex">
        <div class="btn phone-btn" @click="changeCurrentCom('ValiCodeCom')">账号登录</div>
        <div class="btn code-btn" @click="changeCurrentCom('PhoneCom')">手机号登录</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getQrCodeImg, getQrStatus, loginByWx } from '@/apis/index.js'
let timer = null
export default {
  name: 'QrCom',
  data() {
    return {
      qrImg: '',
      cid: '',
      isNotWork: false,
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    clearTimeout(timer)
  },
  methods: {
    async init() {
      this.isNotWork = false
      // 获取二维码图片
      await this.getQrCodeImgMethod()
      // 获取二维码状态
      await this.getQrStatusMethod()
    },
    async getQrCodeImgMethod() {
      let res = await getQrCodeImg()
      // console.log(res.data);
      const { expire, qrImg, uuid } = res.data
      this.qrImg = qrImg
      this.cid = uuid
    },
    async getQrStatusMethod() {
      clearTimeout(timer)
      timer = setTimeout(async () => {
        let res = await getQrStatus(this.cid)
        const { data: status } = res
        if (status === 0) {
          //未授权
          await this.getQrStatusMethod()
          console.log(status, '未授权')
        } else if (status === 1) {
          //已授权
          console.log('已授权')
          await this.wxLogin()
        } else if (status === 2) {
          // 已失效
          console.log('已失效')
          this.isNotWork = true
        }
      }, 1000)
    },
    async wxLogin() {
      let res = await loginByWx(this.cid)
      // console.log(res);
      const { headimgurl, nickname, weixininfo } = res.data
      if (weixininfo) {
        //需要先绑定账号
        this.$emit('wxBindAccount', { headimgurl, nickname, weixininfo })
      } else {
        this.$emit('loginSuccess', res)
      }
    },
    changeCurrentCom(com, loginCom = true) {
      this.$emit('changeCom', com, loginCom)
    },
  },
}
</script>
<style lang="less" scoped>
.qr-code-container {
  padding: 48px 40px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px 10px 10px 10px;
  .title {
    font-weight: bold;
    font-size: 32px;
    color: #03133d;
    line-height: 34px;
    .high-light {
      margin-left: 10px;
      color: #0677e7;
    }
  }
  .sub-title {
    margin-top: 12px;
    font-size: 18px;
    color: #68718b;
    line-height: 24px;
  }
  .qr_code_box {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    img {
      width: 200px;
      height: 200px;
    }
  }
  .form-bot {
    margin-top: 24px;
    .gap-row {
      font-size: 14px;
      color: #68718b;
      &::before {
        content: '';
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 13px;
        display: inline-block;
        width: 163px;
        height: 1px;
        background-color: #e6e8ec;
      }
      &::after {
        content: '';
        vertical-align: middle;
        margin-left: 13px;
        margin-top: -3px;
        display: inline-block;
        width: 163px;
        height: 1px;
        background-color: #e6e8ec;
      }
    }
    .other-btn {
      margin-top: 24px;
    }
    .btn {
      width: 182px;
      height: 54px;
      text-align: center;
      line-height: 54px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #e6e8ec;
      cursor: pointer;
    }
    .phone-btn {
      margin-right: 16px;
      &::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 12px;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/login/count.png);
        background-size: contain;
      }
    }
    .code-btn::before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      margin-top: -3px;
      width: 24px;
      height: 24px;
      margin-right: 12px;
      background-image: url(../../../assets/login/phone.png);
      background-size: contain;
    }
  }
}
</style>
